import React, { useRef } from "react";
import { Button, Card, Divider, Tabs, Modal, message } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import PoForm from "./PoForm";
import PoDetailList from "./PoDetailList";
import { useModel, useModelDispatchers } from "../../../models";
import PaymentDrawer from "./PaymentDrawer";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import UpOutlined from "@ant-design/icons/lib/icons/UpOutlined";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import PoPrint from "./PoPrint";
import TransferDrawer from "./TransferDrawer";
import { debounce } from "lodash";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const { closeNav } = useModelDispatchers("nav");
    const [
        { selectedDocument, formExpand },
        {
            setPaymentDrawerVisible, disable, whConfirm, toggleExpand,
            setTransferDrawerVisible, loadPo
        }
    ] = useModel("purchasePo");

    const [{ preview }, { setPreview }] = useModel("global")

    const history = useHistory();
    const formRef = useRef();
    const printRef = useRef();

    const getForm = () => {
        return formRef.current.form();
    };

    const onPrint = () => {
        setPreview({
            visible: true,
            __html: printRef.current.dom().innerHTML
        })
    }
    const onDisable = () => {
        Modal.confirm({
            title: "确认作废此单据？",
            centered: true,
            closable: true,
            onOk: () => {
                disable({ data: selectedDocument.id })
            },
            onCancel: () => { }
        });
    }
    const onWhConfirm = async () => {
        // whConfirm({data: selectedDocument.id})
        /*getForm().validateFields().then(formData => {
            /!*const {id} = selectedDocument;
            const data = {...formData, details: documentMaterialList, id};
            console.log(data);*!/
            /!*update({showMsg: true, data})
            whConfirm({data: selectedDocument.id})*!/
            whConfirm({data: selectedDocument.id});
        })*/
        let ret = await formRef.current.update()
        if (ret) {
            const { id: data } = selectedDocument;
            await whConfirm({ showMsg: true, data })
            await onRefresh();
        }
    }
    const onSettle = () => {
        setPaymentDrawerVisible(true);
    }
    const onSave = () => {
        formRef.current.update();
    }
    const onBack = () => {
        closeNav();
        goPage(history, "2-3");
    }
    const onRefresh = async () => {
        const { id } = selectedDocument;
        await loadPo({ showMsg: true, data: id })
    }
    const onToggleExpand = () => {
        toggleExpand();
    }
    const onTransfer = () => {
        setTransferDrawerVisible(true);
    }

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>

                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8" onClick={onPrint}>采购单明细</span>
                    <span
                        className="margin-left-16">
                        {selectedDocument.purchaseCode} [{selectedDocument.orderStatusName}]
                    </span>
                    <span
                        className="margin-left-16"
                        onClick={onToggleExpand}
                        style={{ cursor: "pointer" }}
                    >
                        {formExpand ? <UpOutlined /> : <DownOutlined />}
                    </span>
                    <span className="margin-left-8 color-red ">{selectedDocument.isReplenish ? "已补单" : ""}</span>
                </h3>
                <div style={{ width: "724px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_CANCEL}>
                        <Button
                            onClick={onDisable}
                            disabled={
                                !(selectedDocument.orderStatus === "025001"
                                    || selectedDocument.orderStatus === "025002")
                            }
                        > 作废
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_PRINT}>
                        <Button className="margin-left-8" onClick={onPrint}>打印</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_BILL}>
                        <Button
                            className="margin-left-8"
                            onClick={onSettle}
                            disabled={selectedDocument.orderType === "007002" || !(selectedDocument.orderStatus === "025003" || selectedDocument.orderStatus === "025004")}
                        >结算
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_D_BILL}>
                        <Button
                            className="margin-left-8"
                            onClick={onSettle}
                            disabled={selectedDocument.orderType === "007001" || !(selectedDocument.orderStatus === "025003" || selectedDocument.orderStatus === "025004")}
                        >
                            直发结算
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_TRANS}>
                        <Button
                            className="margin-left-8"
                            onClick={onTransfer}
                        >
                            转销售单
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_CONFIRM}>
                        <Button
                            className="margin-left-8"
                            onClick={debounce(onWhConfirm, 600)}
                            disabled={selectedDocument.orderType === "007002" || !(selectedDocument.orderStatus === "025002")} //直发
                        >
                            库房确认
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_D_CONFIRM}>
                        <Button
                            className="margin-left-8"
                            onClick={debounce(onWhConfirm, 600)}
                            disabled={selectedDocument.orderType === "007001" || !(selectedDocument.orderStatus === "025002")} //常规
                        >
                            直发确认
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_SAVE}>
                        <Button
                            className="margin-left-8"
                            type="primary"
                            onClick={debounce(onSave, 600)}
                            disabled={
                                selectedDocument.orderStatus === "025005"//禁用
                                || selectedDocument.orderStatus === "025004"//结算
                                || selectedDocument.orderStatus === "025003"//库房确认
                            }
                        >
                            保存
                        </Button>
                    </YhAuth>
                    <Button
                        className="margin-left-8"
                        // onClick={debounce(onRefresh, 600)}
                        onClick={() => { console.log(selectedDocument) }}
                    >
                        刷新
                    </Button>
                    <Button
                        className="margin-left-8"
                        onClick={onBack}
                    >
                        返回
                    </Button>
                </div>
            </div>
        )
    }
    return (
        <>
            <Card
                title={<Title />}
                bordered={true}
                className="margin-top-8"
            >
                {/*<Tabs tabPosition="top">
                <Tabs.TabPane tab="基本信息" key="1">
                    <PoForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="商品明细" key="2">
                    <PoDetailList/>
                </Tabs.TabPane>
            </Tabs>*/}

                <PoForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
                <Divider orientation="left" />
                <PoDetailList getForm={getForm} />
                <PaymentDrawer getForm={getForm} />
                <TransferDrawer getForm={getForm} />
                <PoPrint printRef={printRef} />
            </Card>
        </>
    );
}